"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1310],{

/***/ 23612:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/campaign_analytics.6e088f97.png","height":733,"width":1195,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAIAAAD38zoCAAAAbElEQVR42h2ISQ7CMBDA5iUoKoFktjZ7JK5AaOH//6GtZflgGGMTjUh6yLIsOeUqGiDlcrVumtDZSLd+MTv3/QDiXGh0+VVeEz0LD3EPYw3M0rt+q7ybrlU/TbfCL3IZvBeiyBTPJqag3NCHP16mFh5w6UyWAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":5});

/***/ }),

/***/ 98179:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/emails-modal-screen.572ecd03.png","height":934,"width":1630,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAIAAAD38zoCAAAAg0lEQVR42mMQF5fU0dFVV9eQlpYWE5OUkpJRVtUQF5diEBUTl5KS9vYNdHLxsbF1VFXTVFRSFxEVZ+AXENLU0rKytjcxtdLS1tfVM5aTlRUQFGIQFhFVUFSSEJf0C4wMDIlVVFCSlJIRFBJmAGIRUTE+Ph5tPVMdA3MeHi4hEVFBIREAQQMQwuR6lOEAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":5});

/***/ }),

/***/ 16803:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/inbox-screen.5336cad2.png","height":971,"width":1715,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAARVBMVEX////+/v79/f3k5OTj4+PY2Nh7e313d3lyc3VrbG1UVFZTVFZOT1AwMTMuLzItLzIqKy8mJikYHCMRExoPEhkAAAoAAABXOEl8AAAAMElEQVR42hXItxEAIAwEsCfa5Oz9RwU6ndBjFdnrIDfyzBSQpoVWcChioD6GvNFwFyeeAWMS41R0AAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":5});

/***/ }),

/***/ 49271:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/steps-screen.e48513b6.png","height":790,"width":1389,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAIAAAD38zoCAAAAdUlEQVR42kWJ2wqCQBQAz38knb2WWBKuHpW9KNGmhET2/z/j+uTLwMzAK87WBlO3bWev+d0Yek+fhnrwfqiqZlm+6/qXKs9OWZx/vZ9gGJ/OhaIoGVfIJBcaUTAuwYZI3aj07Ywi1bQTubhA+aCaHDK9+zH0BvM9FhrdeWsnAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":5});

/***/ }),

/***/ 21310:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var babel_plugin_superjson_next_tools__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10828);
/* harmony import */ var babel_plugin_superjson_next_tools__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(babel_plugin_superjson_next_tools__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35250);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65184);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(styled_jsx_style__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var beskar_landing__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84045);
/* harmony import */ var beskar_src_landing__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98226);
/* harmony import */ var _app_components_specific__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44329);
/* harmony import */ var _heroicons_react_solid__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(799);
/* harmony import */ var _heroicons_react_solid__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(23667);
/* harmony import */ var _heroicons_react_solid__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(41014);
/* harmony import */ var _heroicons_react_solid__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(89361);
/* harmony import */ var _heroicons_react_solid__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(60651);
/* harmony import */ var _heroicons_react_solid__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(80431);
/* harmony import */ var baby_i_am_faded__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(37833);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(65443);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var next_auth_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(68278);
/* harmony import */ var next_auth_react__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_auth_react__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(86037);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(77577);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(70079);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(93145);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var beskar_colors__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(46159);
/* harmony import */ var beskar_colors__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(beskar_colors__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var beskar_dashboard__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(73132);

// images















function Page(param) {
    var products = param.products;
    var status = (0,next_auth_react__WEBPACK_IMPORTED_MODULE_7__.useSession)().status;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_9__.useRouter)();
    var degree = 0.1;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
        className: "jsx-d232c94ed63d1a1d" + " " + "text-gray-100 dark bg-gray-900 ",
        children: [
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((styled_jsx_style__WEBPACK_IMPORTED_MODULE_2___default()), {
                id: "d232c94ed63d1a1d",
                children: "html{color-scheme:dark!important}"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Bg, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_8__/* .NextSeo */ .PB, {
                title: "Salespack - Cold email & warmup automation",
                description: "Automate your sales process with cold email, warmup, and follow-up automation. Send personalized emails to your leads and get more responses.",
                canonical: "https://salespack.io"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(beskar_landing__WEBPACK_IMPORTED_MODULE_3__/* .RootPageContainer */ .h1, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_app_components_specific__WEBPACK_IMPORTED_MODULE_5__/* .MyNavbar */ .RR, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(beskar_landing__WEBPACK_IMPORTED_MODULE_3__/* .Hero */ .VM, {
                        className: "dark",
                        animate: {
                            whenInView: false,
                            delay: 100
                        },
                        bullet: "beta",
                        // image={
                        //     <div className='flex h-full items-end'>
                        //         <img
                        //             src={heroImage.src}
                        //             className={clsx(
                        //                 'opacity-80 min-w-screen min-w-[600px] md:min-w-[1000px]',
                        //                 'lg:-ml-[20px]',
                        //             )}
                        //         />
                        //     </div>
                        // }
                        image: " ",
                        // image={
                        //     <div className='p-8 max-w-[360px] relative'>
                        //         <Image
                        //             className='shadow-lg opacity-40 min-w-[200px]'
                        //             alt='video illustration'
                        //             src={videoCta}
                        //         />
                        //         <VideoModal
                        //             className=''
                        //             aspectRatio={14 / 9}
                        //             button={
                        //                 <div className='flex items-center justify-center absolute inset-0'>
                        //                     <VideoModal.PLayButton className='' />
                        //                 </div>
                        //             }
                        //             youtubeVideoId='ItMyDTdRd_c'
                        //         />
                        //     </div>
                        // }
                        heading: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("span", {
                            className: "jsx-d232c94ed63d1a1d" + " " + "text-6xl font-bold tracking-wide leading-tight",
                            children: [
                                "Your personal sales team,",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {
                                    className: "jsx-d232c94ed63d1a1d"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                    className: "jsx-d232c94ed63d1a1d" + " " + (classnames__WEBPACK_IMPORTED_MODULE_6___default()("to-sky-200 text-transparent from-blue-300  bg-gradient-to-b", "bg-clip-text") || ""),
                                    children: "completely automated"
                                }),
                                " "
                            ]
                        }),
                        subheading: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            className: "jsx-d232c94ed63d1a1d" + " " + "leading-relaxed",
                            children: "Automate your sales process with cold email, track delivery, and follow-up automation. Send personalized emails to your leads and get more responses."
                        }),
                        // fingerprint={
                        //     <div className="font-semibold">
                        //         7-day free trial. No credit card needed
                        //     </div>
                        // }
                        cta: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            className: "jsx-d232c94ed63d1a1d" + " " + (classnames__WEBPACK_IMPORTED_MODULE_6___default()("items-center gap-4 flex-col flex md:items-start", "md:flex-row") || ""),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(beskar_src_landing__WEBPACK_IMPORTED_MODULE_4__/* .GoogleLoginButton */ .tw, {
                                callbackPath: "/board",
                                bg: "blue.300",
                                bgDark: "blue.500",
                                text: "Sign Up With Google",
                                textColor: "white"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(beskar_landing__WEBPACK_IMPORTED_MODULE_3__/* .Divider */ .iz, {
                        animate: {
                            whenInView: false,
                            delay: 300
                        },
                        className: "[&_div]:border-gray-600",
                        heading: "10x your replies and revenue"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(beskar_src_landing__WEBPACK_IMPORTED_MODULE_4__/* .FeaturesBlocks */ .gZ, {
                        blocksClassName: "bg-blue-200 text-gray-900",
                        features: [
                            {
                                heading: "Unlimited email accounts",
                                description: "Use many emails as you want",
                                Icon: _heroicons_react_solid__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z
                            },
                            {
                                heading: "Infinite Scale",
                                description: "Capable of millions of emails per day",
                                Icon: _heroicons_react_solid__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z
                            },
                            {
                                heading: "Automate Follow-ups",
                                description: "Automate your follow-ups",
                                Icon: _heroicons_react_solid__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z
                            },
                            {
                                heading: "Email warmup",
                                description: "Keep your emails out of spam",
                                Icon: _heroicons_react_solid__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z
                            },
                            {
                                heading: "A/B test emails",
                                description: "Experiment with your emails",
                                Icon: _heroicons_react_solid__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z,
                                bullet: "Coming Soon"
                            },
                            {
                                heading: "Analytics",
                                description: "Track delivery, opens, clicks, and replies",
                                Icon: _heroicons_react_solid__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z
                            }
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(beskar_landing__WEBPACK_IMPORTED_MODULE_3__/* .Section */ .$0, {
                        bg: (beskar_colors__WEBPACK_IMPORTED_MODULE_12___default().gray[800]),
                        className: "!py-16",
                        degree: degree,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(beskar_landing__WEBPACK_IMPORTED_MODULE_3__/* .PageContainer */ ._z, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                className: "jsx-d232c94ed63d1a1d" + " " + "flex flex-col items-center ",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                        className: "jsx-d232c94ed63d1a1d" + " " + "text-4xl font-bold",
                                        children: "How Salespack works"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                        className: "jsx-d232c94ed63d1a1d" + " " + "max-w-sm min-w-0 leading-relaxed",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(beskar_dashboard__WEBPACK_IMPORTED_MODULE_13__/* .BlockWithStep */ .fs, {
                                                step: 1,
                                                className: "",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                        className: "jsx-d232c94ed63d1a1d" + " " + "text-xl font-semibold",
                                                        children: "Connect unlimited email accounts (with warm-up included)"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                        className: "jsx-d232c94ed63d1a1d" + " " + "opacity-80",
                                                        children: "Use salespack warmup to increase deliverability"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(beskar_dashboard__WEBPACK_IMPORTED_MODULE_13__/* .BlockWithStep */ .fs, {
                                                step: 2,
                                                className: "",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                        className: "jsx-d232c94ed63d1a1d" + " " + "text-xl font-semibold",
                                                        children: "Automate emails and follow-ups"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                        className: "jsx-d232c94ed63d1a1d" + " " + "opacity-80",
                                                        children: "Salespack will send emails & follow-ups to your leads"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(beskar_dashboard__WEBPACK_IMPORTED_MODULE_13__/* .BlockWithStep */ .fs, {
                                                isLast: true,
                                                step: 3,
                                                className: "",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                        className: "jsx-d232c94ed63d1a1d" + " " + "text-xl font-semibold",
                                                        children: "Increase your replies and revenue"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                        className: "jsx-d232c94ed63d1a1d" + " " + "opacity-80",
                                                        children: [
                                                            "Track and analyze your replies and sales performance",
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {
                                                                className: "jsx-d232c94ed63d1a1d"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {
                                                                className: "jsx-d232c94ed63d1a1d"
                                                            }),
                                                            "Read your leads replies in an unified inbox"
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(beskar_landing__WEBPACK_IMPORTED_MODULE_3__/* .Feature */ .L0, {
                        animate: true,
                        heading: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            className: "jsx-d232c94ed63d1a1d" + " " + "text-5xl leading-normal",
                            children: "Improve email delivery with unlimited warm up"
                        }),
                        subheading: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                            className: "jsx-d232c94ed63d1a1d",
                            children: [
                                "Moving from a subdomain to a subdirectory has been proved to improve your domain authority and search traffic.",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {
                                    className: "jsx-d232c94ed63d1a1d"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {
                                    className: "jsx-d232c94ed63d1a1d"
                                }),
                                "Salespack also auto generates a sitemap with all your subpaths."
                            ]
                        }),
                        bullet: "Use Case",
                        // image={
                        //     <div className='max-w-[400px]'>
                        //         <BrowserWindow>
                        //             <div className='w-[400px] h-[220px] bg-gray-800' />
                        //         </BrowserWindow>
                        //     </div>
                        // }
                        image: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            className: "jsx-d232c94ed63d1a1d" + " " + "w-[500px] md:mt-6 rounded-md",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_11___default()), {
                                src: __webpack_require__(23612),
                                placeholder: "blur",
                                className: classnames__WEBPACK_IMPORTED_MODULE_6___default()("rounded-md shrink-0 overflow-hidden")
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: "jsx-d232c94ed63d1a1d" + " " + "py-8",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(beskar_landing__WEBPACK_IMPORTED_MODULE_3__/* .Section */ .$0, {
                            bg: (beskar_colors__WEBPACK_IMPORTED_MODULE_12___default().gray[800]),
                            className: "!py-16",
                            degree: degree,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(beskar_landing__WEBPACK_IMPORTED_MODULE_3__/* .Feature */ .L0, {
                                flip: true,
                                animate: true,
                                heading: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                    className: "jsx-d232c94ed63d1a1d" + " " + "text-5xl leading-normal",
                                    children: "Schedule emails and followups"
                                }),
                                subheading: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                    className: "jsx-d232c94ed63d1a1d" + " " + "",
                                    children: [
                                        "Salespack supports any websites that does not apply CORS restrictions.",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {
                                            className: "jsx-d232c94ed63d1a1d"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {
                                            className: "jsx-d232c94ed63d1a1d"
                                        }),
                                        "Basically you can host all services that also offer custom domains.",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {
                                            className: "jsx-d232c94ed63d1a1d"
                                        })
                                    ]
                                }),
                                bullet: "Use Case",
                                image: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                    className: "jsx-d232c94ed63d1a1d" + " " + "max-w-[500px] mt-2 md:-ml-8",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(beskar_src_landing__WEBPACK_IMPORTED_MODULE_4__/* .BrowserWindow */ .Uc, {
                                        host: "salespack.io",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_11___default()), {
                                            src: __webpack_require__(49271),
                                            placeholder: "blur",
                                            className: classnames__WEBPACK_IMPORTED_MODULE_6___default()("border-0 shrink-0 bg-gray-900 ")
                                        })
                                    })
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: "jsx-d232c94ed63d1a1d" + " " + "py-8",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(beskar_landing__WEBPACK_IMPORTED_MODULE_3__/* .Feature */ .L0, {
                            animate: true,
                            heading: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                className: "jsx-d232c94ed63d1a1d" + " " + "text-5xl leading-normal",
                                children: "Inbox with all your accounts"
                            }),
                            subheading: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                className: "jsx-d232c94ed63d1a1d" + " " + "",
                                children: [
                                    "Salespack aggregates all your emails in one inbox you can easily monitor and reply to.",
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {
                                        className: "jsx-d232c94ed63d1a1d"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {
                                        className: "jsx-d232c94ed63d1a1d"
                                    }),
                                    "Manage all your leads in one place. Stop wasting times with IMAP clients you have to connect for every account."
                                ]
                            }),
                            bullet: "Inbox",
                            image: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                className: "jsx-d232c94ed63d1a1d" + " " + "max-w-[500px] mt-2",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(beskar_src_landing__WEBPACK_IMPORTED_MODULE_4__/* .BrowserWindow */ .Uc, {
                                    host: "salespack.io",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_11___default()), {
                                        placeholder: "blur",
                                        src: __webpack_require__(16803),
                                        className: classnames__WEBPACK_IMPORTED_MODULE_6___default()("border-0 shrink-0 brightness-150 bg-gray-900 ", "max-h-[300px]")
                                    })
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: "jsx-d232c94ed63d1a1d" + " " + "py-8",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(beskar_landing__WEBPACK_IMPORTED_MODULE_3__/* .Section */ .$0, {
                            bg: (beskar_colors__WEBPACK_IMPORTED_MODULE_12___default().gray[800]),
                            className: "!py-16",
                            degree: degree,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(beskar_landing__WEBPACK_IMPORTED_MODULE_3__/* .Feature */ .L0, {
                                animate: true,
                                flip: true,
                                heading: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                    className: "jsx-d232c94ed63d1a1d" + " " + "text-5xl leading-normal",
                                    children: "Create email accounts with your domain directly inside Salespack"
                                }),
                                subheading: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                    className: "jsx-d232c94ed63d1a1d" + " " + "",
                                    children: [
                                        "With Salespack you can create your email accounts without having to rely on Gmail, Outlook, etc.",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {
                                            className: "jsx-d232c94ed63d1a1d"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {
                                            className: "jsx-d232c94ed63d1a1d"
                                        }),
                                        "You can connect your custom domain and have the best email settings to send cold email in no time"
                                    ]
                                }),
                                bullet: "Email Provider",
                                image: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                    className: "jsx-d232c94ed63d1a1d" + " " + "max-w-[500px] md:-ml-12 mt-2",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(beskar_src_landing__WEBPACK_IMPORTED_MODULE_4__/* .BrowserWindow */ .Uc, {
                                        host: "salespack.io",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_11___default()), {
                                            placeholder: "blur",
                                            src: __webpack_require__(98179),
                                            className: classnames__WEBPACK_IMPORTED_MODULE_6___default()("border-0 shrink-0 brightness-150 bg-gray-900 ", "max-h-[300px]")
                                        })
                                    })
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(baby_i_am_faded__WEBPACK_IMPORTED_MODULE_20__/* .Faded */ .A, {
                        whenInView: true,
                        triggerOnce: true,
                        cascade: true,
                        className: "relative flex flex-col gap-8 items-center ",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h2", {
                                className: "jsx-d232c94ed63d1a1d" + " " + "text-6xl font-extrabold text-gray-100 text-center",
                                children: "Pricing"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_app_components_specific__WEBPACK_IMPORTED_MODULE_5__/* .MyPricing */ .KD, {
                                animate: true,
                                orgId: "",
                                promptLogin: function promptLogin() {
                                    return (0,next_auth_react__WEBPACK_IMPORTED_MODULE_7__.signIn)();
                                },
                                products: products,
                                hideUpgradeButton: true
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_app_components_specific__WEBPACK_IMPORTED_MODULE_5__/* .MyFaq */ .tO, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_app_components_specific__WEBPACK_IMPORTED_MODULE_5__/* .MyFooter */ .iX, {})
                ]
            })
        ]
    });
}
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = ((0,babel_plugin_superjson_next_tools__WEBPACK_IMPORTED_MODULE_0__.withSuperJSONPage)(Page));
function Bg() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((styled_jsx_style__WEBPACK_IMPORTED_MODULE_2___default()), {
                id: "950cb27525699f0b",
                children: '.background_main__HFlNS{width:100vw;min-height:100vh;position:absolute;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;padding:120px 24px 160px;pointer-events:none}.background_content__pv7b5{-webkit-transform:translateX(0px)translateY(0px)translateZ(0px);-moz-transform:translateX(0px)translateY(0px)translateZ(0px);transform:translateX(0px)translateY(0px)translateZ(0px);max-width:1800px;background-image:-webkit-radial-gradient(30%10%,,#1b72f5 0,transparent 100%);background-image:-moz-radial-gradient(30%10%,,#1b72f5 0,transparent 100%);background-image:-o-radial-gradient(30%10%,,#1b72f5 0,transparent 100%);background-image:radial-gradient(at 30%10%,#1b72f5 0,transparent 100%);position:absolute;content:"";width:100%;height:40%;-webkit-filter:blur(100px)saturate(150%);filter:blur(100px)saturate(150%);top:80px;opacity:.13}'
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "jsx-950cb27525699f0b" + " " + "background_main__HFlNS",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                    className: "jsx-950cb27525699f0b" + " " + "background_content__pv7b5"
                })
            })
        ]
    });
}


/***/ })

}]);